import { validateFinnishSSN } from '@op/opds.validate';
import { buildElementId } from '../utils';
import {
  ValidateRegExp,
  ValidateSSN,
  ValidateSegmented,
  ValidateSelector,
} from './ElementValidators';

const dataFormater = (newErrors) => ({
  add: newErrors.add.filter(Boolean),
  remove: newErrors.remove.filter(Boolean),
});

const getValue = (answer) => {
  return (answer || { value: '' }).value;
};

const validateLongTrip = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  newErrors = ValidateSelector(
    getValue(questions.longTrip),
    buildElementId(id, 'TRAVEL_LONGTRIP'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
          questions.longTrip?.question || getMessage('labelText.longTrip')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
  return newErrors;
};

const validateLuggageInsuranceMe = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  newErrors = ValidateSegmented(
    getValue(questions.luggageInsuranceMe),
    buildElementId(id, 'TRAVEL_LAGUAGEINSURANCEME'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
          questions.luggageInsuranceMe?.question ||
          getMessage('labelText.luggageInsuranceMe')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
  return newErrors;
};

const validateCompetitiveSportsMe = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  newErrors = ValidateSegmented(
    getValue(questions.competitiveSportsMe),
    buildElementId(id, 'TRAVEL_COMPETITIVESPORTSME'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
          questions.competitiveSportsMe?.question ||
          getMessage('labelText.competitiveSportsMe')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
  return newErrors;
};

const validateHighRiskSportsMe = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  newErrors = ValidateSegmented(
    getValue(questions.highRiskSportsMe),
    buildElementId(id, 'TRAVEL_HIGHRISKSPORTSME'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
          questions.highRiskSportsMe?.question ||
          getMessage('labelText.highRiskSportsMe')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
  return newErrors;
};

const validateInsuranceIncludesMe = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  if (
    questions.luggageInsuranceMe &&
    questions.luggageInsuranceMe.value === 'Yes'
  ) {
    newErrors = ValidateSelector(
      getValue(questions.insuranceIncludesMe),
      buildElementId(id, 'TRAVEL_INSURANCEINCLUDESME'),
      newErrors,
      validateAll,
      questionID,
      getMessage
        ? `${caption} : ${
            questions.insuranceIncludesMe?.question ||
            getMessage('labelText.insuranceIncludesPackages')
          } - ${getMessage('error.fill.in.missing.information')}`
        : ''
    );
  }
  return newErrors;
};

const validateWhichSportsMe = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  if (
    questions.competitiveSportsMe &&
    questions.competitiveSportsMe.value === 'Yes'
  ) {
    let makeMessage =
      questions.whichSportsMe?.errorLabel ||
      (getMessage
        ? `${caption} : ${
            questions.whichSportsMe?.question ||
            getMessage('labelText.whichSports')
          } - ${getMessage('error.fill.in.missing.information')}`
        : '');
    makeMessage = makeMessage.replace(
      '- undefined',
      (getMessage ?? questions.travelType.getMessage)(
        'error.fill.in.missing.information'
      )
    );
    newErrors = ValidateRegExp({
      value: getValue(questions.whichSportsMe),
      id: buildElementId(id, 'TRAVEL_WHICHSPORTSME'),
      newErrors,
      validateAll,
      length: 1,
      questionID,
      regExp: '^[\\sa-zA-Z0-9åäöÅÄÖ.\\u0023,?!()+-/&:"\'@%€]+$',
      errorLabel: makeMessage,
    });
  }
  return newErrors;
};

const validateWhichHighRiskSportsMe = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  if (
    questions.highRiskSportsMe &&
    questions.highRiskSportsMe.value === 'Yes'
  ) {
    let makeMessage =
      questions.whichHighRiskSportsMe?.errorLabel ||
      (getMessage
        ? `${caption} : ${
            questions.whichHighRiskSportsMe?.question ||
            getMessage('labelText.whichHighRiskSports')
          } - ${getMessage('error.fill.in.missing.information')}`
        : '');
    makeMessage = makeMessage.replace(
      '- undefined',
      (getMessage ?? questions.travelType.getMessage)(
        'error.fill.in.missing.information'
      )
    );
    newErrors = ValidateRegExp({
      value: getValue(questions.whichHighRiskSportsMe),
      id: buildElementId(id, 'TRAVEL_WHICHHIGHRISKSPORTSME'),
      newErrors,
      validateAll,
      length: 1,
      questionID,
      regExp: '^[\\sa-zA-Z0-9åäöÅÄÖ.\\u0023,?!()+-/&:"\'@%€]+$',
      errorLabel: makeMessage,
    });
  }
  return newErrors;
};

const makeTravelTypeME = (
  newErrors,
  id,
  questions,
  validateAll,
  questionID,
  caption,
  getMessage
) => {
  newErrors = validateLongTrip(newErrors, id, questions, validateAll, questionID, caption, getMessage);
  newErrors = validateLuggageInsuranceMe(newErrors, id, questions, validateAll, questionID, caption, getMessage);
  newErrors = validateInsuranceIncludesMe(newErrors, id, questions, validateAll, questionID, caption, getMessage);
  newErrors = validateCompetitiveSportsMe(newErrors, id, questions, validateAll, questionID, caption, getMessage);
  newErrors = validateWhichSportsMe(newErrors, id, questions, validateAll, questionID, caption, getMessage);
  newErrors = validateHighRiskSportsMe(newErrors, id, questions, validateAll, questionID, caption, getMessage);
  newErrors = validateWhichHighRiskSportsMe(newErrors, id, questions, validateAll, questionID, caption, getMessage);
  return dataFormater(newErrors);
};

const validateFirstNameFamilyMember = (
  newErrors,
  id,
  questions,
  validateAll,
  questionID,
  caption,
  getMessage
) => {
  let makeMessage =
    questions.firstNameFamilyMember?.errorLabel ||
    (getMessage
      ? `${caption} : ${
          questions.firstNameFamilyMember?.question ||
          getMessage('labelText.FirstName')
        } - ${getMessage('error.fill.in.missing.information')}`
      : '');
  makeMessage = makeMessage.replace(
    '- undefined',
    (getMessage ?? questions.travelType.getMessage)(
      'error.fill.in.missing.information'
    )
  );
  newErrors = ValidateRegExp({
    value: getValue(questions.firstNameFamilyMember),
    id: buildElementId(id, 'TRAVEL_FIRSTNAMEFAMILYMEMBER'),
    newErrors,
    validateAll,
    length: 1,
    questionID,
    regExp:
      "(^[a-zA-Z\\u00C0-\\u017F'´`]+([ |-][a-zA-Z\\u00C0-\\u017F'´`]+)*$)|(^$)",
    errorLabel: makeMessage,
  });
  return newErrors;
};

const validateLastNameFamilyMember = (
  newErrors,
  id,
  questions,
  validateAll,
  questionID,
  caption,
  getMessage
) => {
  let setMessage =
    questions.lastNameFamilyMember?.errorLabel ||
    (getMessage
      ? `${caption} : ${
          questions.lastNameFamilyMember?.question ||
          getMessage('labelText.LastName')
        } - ${getMessage('error.fill.in.missing.information')}`
      : '');
  setMessage = setMessage.replace(
    '- undefined',
    (getMessage ?? questions.travelType.getMessage)(
      'error.fill.in.missing.information'
    )
  );

  newErrors = ValidateRegExp({
    value: getValue(questions.lastNameFamilyMember),
    id: buildElementId(id, 'TRAVEL_LASTNAMEFAMILYMEMBER'),
    newErrors,
    validateAll,
    length: 1,
    questionID,
    regExp:
      "(^[a-zA-Z\\u00C0-\\u017F'´`]+([ |-][a-zA-Z\\u00C0-\\u017F'´`]+)*$)|(^$)",
    errorLabel: setMessage,
  });
  return newErrors;
};

const validateSecurityIdFamilyMember = (
  newErrors,
  id,
  questions,
  validateAll,
  questionID,
  caption,
  getMessage
) => {
  let ssnMessage =
    questions.securityIdFamilyMember?.errorLabel ||
    (getMessage
      ? `${caption} : ${
          questions.securityIdFamilyMember?.question ||
          getMessage('labelText.SecurityId')
        } - ${getMessage('error.fill.in.missing.information')}`
      : '');
  ssnMessage = ssnMessage.replace(
    '- undefined',
    (getMessage ?? questions.travelType.getMessage)(
      'error.fill.in.missing.information'
    )
  );

  newErrors = ValidateSSN(
    getValue(questions.securityIdFamilyMember),
    buildElementId(id, 'TRAVEL_SECURITYIDFAMILYMEMBER'),
    newErrors,
    validateAll,
    1,
    questionID,
    validateFinnishSSN(getValue(questions.securityIdFamilyMember)),
    ssnMessage
  );
  return newErrors;
};

const validateLongTripFamilyMember = (
  newErrors,
  id,
  questions,
  validateAll,
  questionID,
  caption,
  getMessage
) => {
  newErrors = ValidateSelector(
    getValue(questions.longTripFamilyMember),
    buildElementId(id, 'TRAVEL_LONGTRIPFAMILYMEMBER'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
          questions.longTripFamilyMember?.question ||
          getMessage('labelText.longTrip')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
  return newErrors;
};

const validateCompetitiveSportsFamily = (
  newErrors,
  id,
  questions,
  validateAll,
  questionID,
  caption,
  getMessage
) => {
  newErrors = ValidateSegmented(
    getValue(questions.competitiveSportsFamilyMember),
    buildElementId(id, 'TRAVEL_COPETITIVESPORTSFAMILYMEMBER'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
          questions.competitiveSportsFamilyMember?.question ||
          getMessage('labelText.competitiveSportsMe')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
  return newErrors;
};

const validateHighRiskSportsFamily = (
  newErrors,
  id,
  questions,
  validateAll,
  questionID,
  caption,
  getMessage
) => {
  newErrors = ValidateSegmented(
    getValue(questions.highRiskSportsFamilyMember),
    buildElementId(id, 'TRAVEL_HIGHRISKSPORTSFAMILYMEMBER'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
          questions.highRiskSportsFamilyMember?.question ||
          getMessage('labelText.highRiskSportsMe')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
  return newErrors;
};

const validateLuggageInsuranceFamily = (
  newErrors,
  id,
  questions,
  validateAll,
  questionID,
  caption,
  getMessage
) => {
  newErrors = ValidateSegmented(
    getValue(questions.luggageInsuranceFamily),
    buildElementId(id, 'TRAVEL_LUGGAGEINSURANCEFAMILY'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
          questions.luggageInsuranceFamily?.question ||
          getMessage('labelText.luggageInsuranceFamily')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
  return newErrors;
};

const validateWhichSportsFamilyMember = (
  newErrors,
  id,
  questions,
  validateAll,
  questionID,
  caption,
  getMessage
) => {
  if (
    questions.competitiveSportsFamilyMember &&
    questions.competitiveSportsFamilyMember.value === 'Yes'
  ) {
    let makeMessage =
      questions.whichSportsFamilyMember?.errorLabel ||
      (getMessage
        ? `${caption} : ${
            questions.whichSportsFamilyMember?.question ||
            getMessage('labelText.whichSports')
          } - ${getMessage('error.fill.in.missing.information')}`
        : '');
    makeMessage = makeMessage.replace(
      '- undefined',
      (getMessage ?? questions.travelType.getMessage)(
        'error.fill.in.missing.information'
      )
    );

    newErrors = ValidateRegExp({
      value: getValue(questions.whichSportsFamilyMember),
      id: buildElementId(id, 'TRAVEL_WHICHSPORTSFAMILYMEMBER'),
      newErrors,
      validateAll,
      length: 1,
      questionID,
      regExp: '^[\\sa-zA-Z0-9åäöÅÄÖ.\\u0023,?!()+-/&:"\'@%€]+$',
      errorLabel: makeMessage,
    });
  }
  return newErrors;
};

const validateWhichHighRiskSportsFamilyMember = (
  newErrors,
  id,
  questions,
  validateAll,
  questionID,
  caption,
  getMessage
) => {
  if (
    questions.highRiskSportsFamilyMember &&
    questions.highRiskSportsFamilyMember.value === 'Yes'
  ) {
    let makeMessage =
      questions.whichHighRiskSportsFamilyMember?.errorLabel ||
      (getMessage
        ? `${caption} : ${
            questions.whichHighRiskSportsFamilyMember?.question ||
            getMessage('labelText.whichHighRiskSports')
          } - ${getMessage('error.fill.in.missing.information')}`
        : '');
    makeMessage = makeMessage.replace(
      '- undefined',
      (getMessage ?? questions.travelType.getMessage)(
        'error.fill.in.missing.information'
      )
    );

    newErrors = ValidateRegExp({
      value: getValue(questions.whichHighRiskSportsFamilyMember),
      id: buildElementId(id, 'TRAVEL_WHICHHIGHRISKSPORTSFAMILYMEMBER'),
      newErrors,
      validateAll,
      length: 1,
      questionID,
      regExp: '^[\\sa-zA-Z0-9åäöÅÄÖ.\\u0023,?!()+-/&:"\'@%€]+$',
      errorLabel: makeMessage,
    });
  }
  return newErrors;
};

const makeTravelTypeFamily = (
  newErrors,
  id,
  questions,
  validateAll,
  questionID,
  caption,
  getMessage
) => {
  newErrors = validateFirstNameFamilyMember(
    newErrors,
    id,
    questions,
    validateAll,
    questionID,
    caption,
    getMessage
  );

  newErrors = validateLastNameFamilyMember(
    newErrors,
    id,
    questions,
    validateAll,
    questionID,
    caption,
    getMessage
  );

  newErrors = validateSecurityIdFamilyMember(
    newErrors,
    id,
    questions,
    validateAll,
    questionID,
    caption,
    getMessage
  );

  newErrors = validateLongTripFamilyMember(
    newErrors,
    id,
    questions,
    validateAll,
    questionID,
    caption,
    getMessage
  );

  newErrors = validateCompetitiveSportsFamily(
    newErrors,
    id,
    questions,
    validateAll,
    questionID,
    caption,
    getMessage
  );

  newErrors = validateHighRiskSportsFamily(
    newErrors,
    id,
    questions,
    validateAll,
    questionID,
    caption,
    getMessage
  );

  newErrors = validateWhichHighRiskSportsFamilyMember(
    newErrors,
    id,
    questions,
    validateAll,
    questionID,
    caption,
    getMessage
  )

  newErrors = validateLuggageInsuranceFamily(
    newErrors,
    id,
    questions,
    validateAll,
    questionID,
    caption,
    getMessage
  );

  newErrors = validateWhichSportsFamilyMember(
    newErrors,
    id,
    questions,
    validateAll,
    questionID,
    caption,
    getMessage
  );

  return dataFormater(newErrors);
};

const makeTravelTypeLuggage = (
  newErrors,
  id,
  questions,
  validateAll,
  questionID,
  caption,
  getMessage
) => {
  newErrors = ValidateSelector(
    getValue(questions.insuranceIncludesMe1),
    buildElementId(id, 'TRAVEL_INSURANCEINCLUDESME1'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
          questions.insuranceIncludesMe1?.question ||
          getMessage('labelText.insuranceIncludesPackages')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
  return dataFormater(newErrors);
};

const validateTravelQuestions = (
  id,
  questions,
  validateAll,
  questionID,
  errors,
  caption,
  getMessage
) => {
  let newErrors = { add: [], remove: [] };
  const travelType = questions.travelType || { value: '' };

  // Mandatory, validate always type
  newErrors = ValidateSelector(
    travelType.value,
    buildElementId(id, 'TRAVEL_TYPE'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
          travelType.question || getMessage('labelText.insuredItem')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );

  if (validateAll === true && travelType.value === 'choose') {
    newErrors.remove = [
      ...newErrors.remove,
      ...errors
        .filter(
          (record) =>
            record.id.indexOf(id) !== -1 && record.id !== id + '_TRAVEL_TYPE'
        )
        .map((record) => record.id),
    ];
  }

  switch (travelType.value) {
    case 'Me':
      return makeTravelTypeME(
        newErrors,
        id,
        questions,
        validateAll,
        questionID,
        caption,
        getMessage
      );
    case 'Family member':
      return makeTravelTypeFamily(
        newErrors,
        id,
        questions,
        validateAll,
        questionID,
        caption,
        getMessage
      );
    case 'Luggage only':
      return makeTravelTypeLuggage(
        newErrors,
        id,
        questions,
        validateAll,
        questionID,
        caption,
        getMessage
      );
    default:
      return dataFormater(newErrors);
  }
};

export default validateTravelQuestions;
